import { Reveal } from './Reveal';
import LeadForm from './LeadForm';
import { PhoneCall, ArrowRight } from 'lucide-react';
import { WA_DEFAULT_LINK, WA_NUMBER_DISPLAY, waLink } from '../lib/lead';
import { WhatsAppGlyph } from './StickyWhatsApp';

export default function SecondaryLead() {
  return (
    <section className="relative py-20 lg:py-28 bg-brand-bluedark overflow-hidden grain" data-testid="secondary-lead-section">
      <div className="absolute inset-0 hero-grid" aria-hidden="true" />
      <div className="absolute -bottom-40 -left-32 w-[520px] h-[520px] rounded-full bg-brand-orange/15 blur-[140px]" aria-hidden="true" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-brand-orange">Immediate Callback</p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2
              className="mt-4 font-display text-4xl sm:text-5xl lg:text-[3.4rem] font-bold tracking-tight leading-[1.05] text-white text-balance"
              data-testid="secondary-lead-headline"
            >
              Don't Wait for a Court Warrant. <span className="text-brand-orange italic">Clear Your Vehicle Records</span> Today.
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-5 max-w-lg text-base sm:text-lg leading-relaxed text-white/70" data-testid="secondary-lead-subtitle">
              Speak directly to a legal challan consultant or leave your details for an immediate callback.
            </p>
          </Reveal>

          <Reveal delay={0.24}>
            <div className="mt-9 flex flex-col sm:flex-row gap-4">
              <a
                href={WA_DEFAULT_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center justify-center gap-3 rounded-2xl bg-[#25D366] hover:bg-[#1FB855] text-white font-bold px-7 py-4 shadow-2xl shadow-green-600/30 transition-all hover:-translate-y-0.5"
                data-testid="secondary-whatsapp-badge"
              >
                <WhatsAppGlyph size={24} />
                <span className="text-left leading-tight">
                  <span className="block text-[10px] font-bold uppercase tracking-widest text-white/80">Direct WhatsApp</span>
                  <span className="block text-base">{WA_NUMBER_DISPLAY}</span>
                </span>
                <ArrowRight size={18} strokeWidth={2.5} className="transition-transform group-hover:translate-x-1" />
              </a>
              <a
                href="tel:+918383854950"
                className="inline-flex items-center justify-center gap-3 rounded-2xl border-2 border-white/25 hover:border-brand-orange hover:text-brand-orange text-white font-bold px-7 py-4 transition-all hover:-translate-y-0.5"
                data-testid="secondary-call-badge"
              >
                <PhoneCall size={22} />
                <span className="text-left leading-tight">
                  <span className="block text-[10px] font-bold uppercase tracking-widest opacity-70">Direct Call</span>
                  <span className="block text-base">{WA_NUMBER_DISPLAY}</span>
                </span>
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.3}>
            <p className="mt-6 text-xs font-medium text-white/50">
              Callback within minutes, 7 days a week. Or WhatsApp us a photo of your challan at{' '}
              <a
                href={waLink('Hi Settalkar, I am sharing a photo of my traffic challan for settlement.')}
                target="_blank"
                rel="noopener noreferrer"
                className="text-brand-orange font-bold underline underline-offset-2"
              >
                {WA_NUMBER_DISPLAY}
              </a>
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:pl-8">
          <Reveal delay={0.15}>
            <div className="rounded-2xl bg-white/95 backdrop-blur-xl border border-white/60 p-6 sm:p-8 lead-card" data-testid="secondary-form-card">
              <h3 className="font-display text-2xl font-bold text-brand-ink">Get an Immediate Callback</h3>
              <p className="mt-1.5 mb-6 text-xs font-medium text-slate-500">
                Fill this in 30 seconds — a legal consultant calls you back.
              </p>
              <LeadForm variant="secondary" source="secondary" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
